/**
 * @generated SignedSource<<306b41ae027ebed5bc500ec3ea41a586>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreativeDrawerUser$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AddComment" | "CreativeTextFormUser">;
  readonly " $fragmentType": "CreativeDrawerUser";
};
export type CreativeDrawerUser$key = {
  readonly " $data"?: CreativeDrawerUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeDrawerUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeDrawerUser",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreativeTextFormUser"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddComment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5d6bdd7e65a9bba94531500639ba5c73";

export default node;
